import { fromCodeData } from './CodeData.js';
import { Significance } from './Significance.js';
import {
  asBoolean,
  asInstant,
  mapDtoList,
  optionalEnum,
  optionalNumber,
  optionalString,
  requireObject,
} from './parse.js';

/**
 * Mirrors com.medprompt.content.codes.ExistingCode
 *
 * @typedef {object} ExistingCodeData
 * @property {string|null} codeId
 * @property {string|null} dbId
 * @property {string|null} refId
 * @property {string|null} guid
 * @property {import('./CodeData.js').CodeData} code
 * @property {number|string|null} timestamp
 * @property {string|null} significance
 * @property {string|null} quote
 * @property {string|null} description
 * @property {number|null} duration
 * @property {boolean} isSelected
 */

/**
 * @param {object} raw
 * @returns {ExistingCodeData}
 */
export function fromExistingCodeData(raw) {
  const source = requireObject(raw, 'ExistingCode');
  return {
    codeId: optionalString(source.codeId),
    dbId: optionalString(source.dbId),
    refId: optionalString(source.refId),
    guid: optionalString(source.guid),
    code: fromCodeData(source.code),
    timestamp: asInstant(source.timestamp),
    significance: optionalEnum(source.significance, Significance, 'ExistingCode', 'significance'),
    quote: optionalString(source.quote),
    description: optionalString(source.description),
    duration: optionalNumber(source.duration),
    isSelected: asBoolean(source.isSelected),
  };
}

/**
 * @param {unknown} raw
 * @returns {ExistingCodeData[]}
 */
export function fromExistingCodeDataList(raw) {
  return mapDtoList(raw, 'ExistingCode', fromExistingCodeData);
}
